var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isLoaded),expression:"!isLoaded"}],staticClass:"container-sources"},[(_vm.isLoaded)?_c('div',[(!_vm.hasNonCensusSources)?_c('tf-table',_vm._b({scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.categoryType))+" files ")]},proxy:true},(_vm.error)?{key:"error",fn:function(){return [_vm._v(" "+_vm._s(_vm.error)+" ")]},proxy:true}:null],null,true)},'tf-table',{
        tableData: [],
        tableMeta: { columns: [] },
      },false),[_c('empty-table-cell',{attrs:{"slot":"empty"},slot:"empty"},[_vm._v(" There doesn't appear to be any "+_vm._s(_vm.categoryType)+" files. "),_c('router-link',{attrs:{"slot":"cta","to":{
            name: 'AddCoverageSources',
            params: Object.assign({}, _vm.$route.params, // productTypeId is optional so gets 'removed' on route change.
              {categoryType: _vm.categoryType,
              documentId: _vm.documentId}),
          }},slot:"cta"},[_c('tf-button',{attrs:{"type":"secondary","icon":"plus","size":"medium"}},[_vm._v(" Add files ")])],1)],1),_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.categoryType))+" files ")])],2):_vm._l((_vm.sourceTypes.filter(function (ref) {
                var sources = ref.sources;

                return sources.length;
})),function(ref,idx){
          var sources = ref.sources;
          var type = ref.type;
return _c('div',{key:type,staticClass:"container-source-type"},[(sources.length)?_c('tf-table',_vm._b({scopedSlots:_vm._u([(_vm.error)?{key:"error",fn:function(){return [_vm._v(" "+_vm._s(_vm.error)+" ")]},proxy:true}:null,(!idx)?{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.categoryType))+" files ")]},proxy:true}:null,{key:"parentRow",fn:function(ref){
          var rowData = ref.rowData;
return _c('source-table-row',{attrs:{"source":rowData},on:{"delete":_vm.deleteSource,"save":function($event){return _vm.setSourceProp({
              id: $event.id,
              prop: 'name',
              value: $event.name,
            })}}})}}],null,true)},'tf-table',{
            tableData: sources,
            tableMeta: {
              columns: [
                {
                  label: _vm.$options.filters.sourceType(type),
                  prop: 'name',
                },
                {
                  prop: null,
                  width: '30',
                } ],
            },
          },false),[(_vm.hasNonCensusSources && !idx)?_c('router-link',{staticClass:"router-link-add-files",attrs:{"slot":"ctaHeader","to":{
              name: 'AddCoverageSources',
              params: Object.assign({}, _vm.$route.params, // productTypeId is optional so gets 'removed' on route change.
                {categoryType: _vm.categoryType,
                documentId: _vm.documentId}),
            }},slot:"ctaHeader"},[_c('tf-button',{attrs:{"type":"primary","icon":"plus","size":"text-icon"}},[_vm._v(" Add files ")])],1):_vm._e()],1):_vm._e()],1)})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }